module.exports = __webpack_public_path__ + "static/media/aside-1.4daefda3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aside-1.jpg
// module id = 489
// module chunks = 33